import { createTheme } from '@mui/material/styles';

/**
 * Charte graphique – Cuba, France, Sénégal, Cameroun (éviter vert-jaune-rouge = code reggae)
 * Accents: bleu (Cuba/France), rouge, or (tertiary). Pas de bande vert-jaune-rouge.
 * Typo: Titres = Archivo, Corps = Plus Jakarta Sans
 */
const palette = {
  primary: {
    main: '#1A2B48',
    light: '#2d3f5c',
    dark: '#0f1825',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#B22222',
    light: '#c94a4a',
    dark: '#8b1a1a',
    contrastText: '#ffffff',
  },
  tertiary: {
    main: '#D4AF37',
    light: '#e6c55c',
    dark: '#a68b29',
    contrastText: '#1A2B48',
  },
  success: {
    main: '#006400',
    light: '#008c00',
    dark: '#004d00',
    contrastText: '#ffffff',
  },
  background: {
    default: '#fafafa',
    paper: '#ffffff',
  },
  text: {
    primary: '#1A2B48',
    secondary: 'rgba(26, 43, 72, 0.7)',
    disabled: 'rgba(26, 43, 72, 0.38)',
  },
};

const fontHeading = '"Archivo", sans-serif';
const fontBody = '"Plus Jakarta Sans", sans-serif';

const typography = {
  fontFamily: fontBody,
  fontSize: 16,
  fontWeightLight: 400,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: {
    fontFamily: fontHeading,
    fontWeight: 700,
    fontSize: '2rem',
    lineHeight: 1.2,
    letterSpacing: '-0.02em',
  },
  h2: {
    fontFamily: fontHeading,
    fontWeight: 700,
    fontSize: '1.5rem',
    lineHeight: 1.3,
    letterSpacing: '-0.01em',
  },
  h3: {
    fontFamily: fontHeading,
    fontWeight: 600,
    fontSize: '1.25rem',
    lineHeight: 1.35,
  },
  h4: {
    fontFamily: fontHeading,
    fontWeight: 600,
    fontSize: '1.125rem',
    lineHeight: 1.4,
  },
  h5: {
    fontFamily: fontHeading,
    fontWeight: 600,
    fontSize: '1.0625rem',
    lineHeight: 1.4,
  },
  h6: {
    fontFamily: fontHeading,
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: 1.45,
  },
  subtitle1: {
    fontFamily: fontBody,
    fontWeight: 500,
    fontSize: '1rem',
    lineHeight: 1.5,
  },
  subtitle2: {
    fontFamily: fontBody,
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: 1.5,
  },
  body1: {
    fontFamily: fontBody,
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: 1.6,
  },
  body2: {
    fontFamily: fontBody,
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: 1.55,
  },
  button: {
    fontFamily: fontHeading,
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: 1.75,
  },
  caption: {
    fontFamily: fontBody,
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: 1.5,
  },
  overline: {
    fontFamily: fontBody,
    fontWeight: 600,
    fontSize: '0.75rem',
    lineHeight: 1.5,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
  },
};

const shape = {
  borderRadius: 12,
};

const components = {
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        fontFamily: typography.fontFamily,
        fontSize: typography.fontSize,
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: theme.shape.borderRadius * 2,
        boxShadow: '0 4px 24px rgba(26, 43, 72, 0.08)',
        border: '1px solid',
        borderColor: 'rgba(26, 43, 72, 0.06)',
      }),
    },
  },
  MuiButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        textTransform: 'none',
        borderRadius: theme.shape.borderRadius,
        fontWeight: 600,
      }),
    },
  },
  MuiTextField: {
    defaultProps: {
      variant: 'outlined',
    },
    styleOverrides: {
      root: ({ theme }) => ({
        '& .MuiOutlinedInput-root': {
          borderRadius: theme.shape.borderRadius,
        },
      }),
    },
  },
};

export const theme = createTheme({
  palette,
  typography,
  shape,
  components,
});

export default theme;
